<div class="empty-screen-container">
  <div class="empty-screen-content">
    <div class="icon-wrapper">
      <div class="icon-circle">
        <i class="fas {{icon}}"></i>
      </div>
    </div>
    <h3 class="message">{{message}}</h3>
    <p class="sub-message" *ngIf="subMessage">{{subMessage}}</p>
    <button 
      *ngIf="showAction"
      class="action-button"
      (click)="handleActionClick()">
      <i class="fas fa-plus"></i>
      {{actionLabel}}
    </button>
  </div>
</div> 